import type { Theme } from '@mui/material';
import localFont from 'next/font/local';

import { colorSchemes } from './colorSchemes';
import { customShadows } from './customShadows';
import { overrides } from './overrides';
import { shadows } from './shadows';
import { spacing } from './spacing';
import { typography } from './typography';

const MatterMedium = localFont({
  src: [
    {
      path: '../../public/statics/fonts/MatterRegular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/MatterRegular.woff',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/MatterMedium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/MatterMedium.woff',
      weight: '500',
      style: 'normal',
    },
  ],
  variable: '--font-matter-medium',
});

const HelveticaNowText = localFont({
  src: [
    {
      path: '../../public/statics/fonts/HelveticaNowText-ExtraLight.woff2',
      weight: '200',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-ExtraLight.woff',
      weight: '200',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Light.woff',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Regular.woff',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Medium.woff',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Medium.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../../public/statics/fonts/HelveticaNowText-Medium.woff',
      weight: '600',
      style: 'normal',
    },
  ],
  variable: '--font-helvetica-now-text',
});

const NeutrafaceText = localFont({
  src: [
    {
      path: '../../public/statics/fonts/NeutrafaceText-BoldItalic.woff2',
      weight: '700',
      style: 'italic',
    },
    {
      path: '../../public/statics/fonts/NeutrafaceText-BoldItalic.woff',
      weight: '700',
      style: 'italic',
    },
  ],
  variable: '--font-neutraface-text',
});

const theme = (): Theme => {
  return {
    colorSchemeSelector: 'class',
    components: overrides(),
    colorSchemes: colorSchemes(),
    ...spacing,
    shape: {
      borderRadius: 4,
      customBorderRadius: {
        xs: 2,
        sm: 4,
        md: 6,
        lg: 8,
        xl: 10,
      },
    },
    shadows: shadows(),
    typography: typography(
      HelveticaNowText.style.fontFamily,
      MatterMedium.style.fontFamily,
      NeutrafaceText.style.fontFamily
    ),
    customShadows: customShadows(),
    mainColorChannels: {
      light: '46 38 61',
      dark: '231 227 252',
    },
  } as Theme;
};

export { theme };
